import { render, staticRenderFns } from "./qrDiscount.vue?vue&type=template&id=2b227052&scoped=true"
import script from "./qrDiscount.vue?vue&type=script&lang=js"
export * from "./qrDiscount.vue?vue&type=script&lang=js"
import style0 from "./qrDiscount.vue?vue&type=style&index=0&id=2b227052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b227052",
  null
  
)

export default component.exports